// List ongoing weblabs in this file for easy reference throughout the rest of the code base.
//
// Example:
// export const FOO_WEBLAB = 'FOO_BAR'

export const JS_EXAMPLE_1 = 'AAPN_JS_EXAMPLE_1291298'
export const JS_EXAMPLE_2 = 'AAPN_JS_EXAMPLE_1311920'
export const weblabs = [JS_EXAMPLE_1, JS_EXAMPLE_2]
